import logo from './logo.svg';
import React from "react";
import ReactDOM from "react-dom";
import './App.css';
import Main from "./components/Main"



function App() {
    return (
        <div>
            <Main />
           
        </div>
    );
}

export default App;